module.exports = __webpack_public_path__ + "static/media/saramobile.4ff4de18.png";